import React from 'react';
import PropTypes from 'prop-types';
import styles from './BasemapSelectorPane.module.scss';
import { connect } from 'dva';
import Radio from '../../../Form/Radio';

const getBasemapImg = (basemap) => {
  switch (basemap) {
    case 'Satellite':
      return require('../../../../assets/img/basemapIcons/Satellite.png');
    case 'Topographic':
      return require('../../../../assets/img/basemapIcons/Topographic.png');
    case 'Hybrid':
      return require('../../../../assets/img/basemapIcons/Hybrid.png');
    default:
      return '';
  }
};

const BasemapSelectionButton = (props) => {
  const changeBasemap = (basemap) => {
    return () => props.onChange(basemap)
  };

  return (
    <div className={styles.basemapSelectionRow}>
      <img src={getBasemapImg(props.basemap.name)} />
      <Radio
        className={styles.basemapRadio}
        // theme={Radio.THEME.white}
        name={props.basemap.name}
        id={props.basemap.name}
        label={props.basemap.name}
        onChange={changeBasemap(props.basemap.name)}
        checked={props.activeBasemap == props.basemap.name}
      />
    </div>
  );
};

BasemapSelectionButton.propTypes = {
  basemap: PropTypes.object,
  activeBasemap: PropTypes.string,
  onChange: PropTypes.func
};

const BasemapSelectorPane = (props) => {
  return (
    <div className={styles.selectorContents}>
      <p>
        <em>Basemaps</em>
      </p>
      {props.basemaps.map((basemap, i) => {
        return (
          <BasemapSelectionButton
            key={i}
            activeBasemap={props.activeBasemap}
            basemap={basemap}
            onChange={props.onChange}
          />
        );
      })}
    </div>
  );
};

BasemapSelectorPane.propTypes = {
  activeBasemap: PropTypes.string,
  isUpdatingLocation: PropTypes.bool,
  basemaps: PropTypes.array,
  onChange: PropTypes.func,
  onClickX: PropTypes.func
};

export default connect((model) => {
  return {
    activeBasemap: model.map.basemapMode,
    basemaps: model.map.basemaps,
  };
})(BasemapSelectorPane);
